/**
 * Discussions Tab for WooCommerce Products - Admin JS
 *
 * @version 1.2.6
 * @since   1.2.6
 * @author  WPFactory
 */
const iconpicker = require( './modules/iconpicker-manager' );